module.exports = __webpack_public_path__ + "img/m112.aa990bd8.png";